import {
  ProductTypeName,
  ProductStatusEnum,
  FullCatalogManagementProduct as ProductProfileDto,
  FullStorefrontProductWithImages as ProductDto,
  StorefrontProduct as StorefrontProductDto,
  ProductManufacturer as manufacturerDto,
  SearchStagingProductBySku as NewProductFoundDto,
  SearchProductBySku as ProductFoundDto,
  RelatedProductCategoryNameEnum,
  ProductType as ProductTypeDto,
  ProductSuggestionsResponse as ProductSuggestionsResponseDto,
  ProductApplicableMarginRulesResponse as ProductMarginsDto,
  ProductMarginRuleType,
  ProductTypePropertySlugEnum,
} from '@electricjs/core_entity-client';

import { engineeringGroup } from './groupData';

const warrantyProfile1: ProductProfileDto = {
  id: '12345',
  created_at: new Date().toISOString(),
  updated_at: new Date().toISOString(),
  name: '3 Years',
  description: 'Warranty description',
  country_code: 'US',
  product_type: {
    id: '2000',
    name: ProductTypeName.Warranty,
    tax_code: 'TAX2000',
    allows_warehousing: false,
    is_virtual: true,
    taa_applicable: true,
  },
  product_origin: {
    id: '',
    name: 'TDSynnex',
  },
  product_manufacturer: {
    id: '10000',
    name: 'Dell',
  },
  manufacturer_part_num: 'PART22221',
  vendor_url: 'www.vendor-url.com',
  vendor_sku: '22221',
  upc: '012345123456',
  unspsc: '43211500',
  price: 79,
  unit_cost: 70,
  contract_price: 70,
  min_advertised_price: 0,
  msrp: 79,
  is_returnable: true,
  taa_compliance: 'INQUIRE',
  status: ProductStatusEnum.Pending,
  product_inventory: {
    id: '100000',
    product_id: '',
    minimum_inventory: 100,
    total: 100,
    inventory_miami_fl: 100,
    inventory_tracy_ca: 100,
    inventory_romeoville_il: 0,
    inventory_southaven_ms: 0,
    inventory_monroe_nj: 0,
    inventory_columbus_oh: 0,
    inventory_suwanee_ga: 0,
    inventory_chino_ca: 0,
    inventory_swedesboro_nj: 0,
    inventory_south_bend_in: 0,
    inventory_fort_worth_tx: 0,
    inventory_fontana_ca: 0,
  },
};

const accessoryProfile1: ProductProfileDto = {
  id: '54321',
  created_at: new Date().toISOString(),
  updated_at: new Date().toISOString(),
  name: 'Laptop Backpack',
  description: 'Accessory description',
  country_code: 'US',
  product_type: {
    id: '3000',
    name: ProductTypeName.Accessory,
    tax_code: 'TAX3000',
    allows_warehousing: true,
    is_virtual: false,
    taa_applicable: false,
  },
  product_origin: {
    id: '',
    name: 'TDSynnex',
  },
  product_manufacturer: {
    id: '10000',
    name: 'Dell',
  },
  manufacturer_part_num: 'PART33331',
  vendor_url: 'www.vendor-url.com',
  vendor_sku: '33331',
  upc: '012345123457',
  unspsc: '43211501',
  price: 49,
  unit_cost: 30,
  contract_price: 30,
  min_advertised_price: 0,
  msrp: 49,
  is_returnable: true,
  taa_compliance: 'INQUIRE',
  status: ProductStatusEnum.Active,
  product_inventory: {
    id: '100001',
    product_id: '',
    minimum_inventory: 100,
    total: 100,
    inventory_miami_fl: 100,
    inventory_tracy_ca: 100,
    inventory_romeoville_il: 0,
    inventory_southaven_ms: 0,
    inventory_monroe_nj: 0,
    inventory_columbus_oh: 0,
    inventory_suwanee_ga: 0,
    inventory_chino_ca: 0,
    inventory_swedesboro_nj: 0,
    inventory_south_bend_in: 0,
    inventory_fort_worth_tx: 0,
    inventory_fontana_ca: 0,
  },
};

const laptopProfile1: ProductProfileDto = {
  id: '0c3efc59-cfc2-448f-8e5b-ce35bac4983b',
  created_at: new Date().toISOString(),
  updated_at: new Date().toISOString(),
  name: 'Laptop 1 (Dell)',
  description: 'The detailed description with markdown',
  country_code: 'US',
  product_type: {
    id: '1000',
    name: ProductTypeName.Laptop,
    tax_code: 'TAX1000',
    allows_warehousing: true,
    is_virtual: false,
    taa_applicable: true,
  },
  product_origin: {
    id: '',
    name: 'TDSynnex',
  },
  product_manufacturer: {
    id: '10000',
    name: 'Dell',
  },
  manufacturer_part_num: 'LAPTOP100',
  vendor_url: 'www.vendor-url.com',
  vendor_sku: '12345',
  upc: '012345123456',
  unspsc: '43211500',
  price: 999,
  unit_cost: 800,
  contract_price: 800,
  min_advertised_price: 0,
  msrp: 999,
  is_returnable: true,
  taa_compliance: 'INQUIRE',
  status: ProductStatusEnum.Pending,
  product_properties: [
    {
      product_type_property: {
        id: '',
        product_type_id: '',
        product_property: 'Display Diagonal Size',
        display_name: 'Screen size (inch)',
        is_displayed: true,
        is_read_only: false,
        is_required: true,
        value_type: '',
      },
      value: '13',
      id: '100000',
      product_id: '',
      product_type_property_id: '',
    },
    {
      product_type_property: {
        id: '',
        product_type_id: '',
        product_property: 'Available Types of Ports',
        display_name: 'Port types',
        is_displayed: false,
        is_read_only: true,
        is_required: true,
        value_type: '',
      },
      value: 'USB',
      id: '100001',
      product_id: '',
      product_type_property_id: '',
    },
  ],
  product_inventory: {
    id: '100000',
    product_id: '',
    minimum_inventory: 100,
    total: 100,
    inventory_miami_fl: 100,
    inventory_tracy_ca: 100,
    inventory_romeoville_il: 0,
    inventory_southaven_ms: 0,
    inventory_monroe_nj: 0,
    inventory_columbus_oh: 0,
    inventory_suwanee_ga: 0,
    inventory_chino_ca: 0,
    inventory_swedesboro_nj: 0,
    inventory_south_bend_in: 0,
    inventory_fort_worth_tx: 0,
    inventory_fontana_ca: 0,
  },
  related_product_categories: [
    {
      id: '',
      name: RelatedProductCategoryNameEnum.Warranties,
      product_id: '',
      selection_type: 'OPTIONAL_ONE',
      related_products: [{ ...warrantyProfile1 }],
    },
    {
      id: '',
      name: RelatedProductCategoryNameEnum.Accessories,
      product_id: '',
      selection_type: 'OPTIONAL_MANY',
      related_products: [{ ...accessoryProfile1 }],
    },
  ],
};

const storefrontWarranty1: StorefrontProductDto = {
  id: '12345',
  name: '1 Year',
  description: 'Warranty description',
  country_code: 'US',
  product_type: {
    id: '2000',
    name: ProductTypeName.Warranty,
    tax_code: 'TAX2000',
    allows_warehousing: false,
    is_virtual: true,
    taa_applicable: true,
  },
  product_manufacturer: {
    name: 'Dell',
  },
  manufacturer_part_num: 'PART22221',
  vendor_sku: '22221',
  price: 0,
  status: ProductStatusEnum.Active,
  product_properties: [
    {
      product_type_property: {
        slug: ProductTypePropertySlugEnum.WarrantyCoverage,
        product_property: 'Warranty Coverage',
        display_name: 'Warranty coverage',
        is_displayed: true,
        value_type: '',
      },
      value: 'Parts and labor; Mail-in repair service; Phone support',
    },
  ],
  product_images: [],
};

const storefrontWarranty2: StorefrontProductDto = {
  ...storefrontWarranty1,
  id: '12346',
  name: '3 Years',
  manufacturer_part_num: 'PART22222',
  vendor_sku: '22222',
  price: 79,
  product_properties: [
    {
      product_type_property: {
        slug: ProductTypePropertySlugEnum.WarrantyCoverage,
        product_property: 'Warranty Coverage',
        display_name: 'Warranty coverage',
        is_displayed: true,
        value_type: '',
      },
      value:
        'Parts and labor; Onsite repair service; Accidental damage protection; 24/7 priority phone support',
    },
  ],
};

const storefrontAccessory1: StorefrontProductDto = {
  id: '54321',
  name: 'Laptop Backpack',
  description: 'Accessory description',
  country_code: 'US',
  product_type: {
    id: '3000',
    name: ProductTypeName.Accessory,
    tax_code: 'TAX3000',
    allows_warehousing: true,
    is_virtual: false,
    taa_applicable: false,
  },
  product_manufacturer: {
    name: 'Dell',
  },
  manufacturer_part_num: 'PART33331',
  vendor_sku: '33331',
  price: 49,
  status: ProductStatusEnum.Active,
  product_images: [],
};

const laptop1: ProductDto = {
  id: '0c3efc59-cfc2-448f-8e5b-ce35bac4983b',
  name: 'Laptop 1 (Dell)',
  description: 'The detailed description with markdown',
  country_code: 'US',
  product_type: {
    id: '1000',
    name: ProductTypeName.Laptop,
    tax_code: 'TAX1000',
    allows_warehousing: true,
    is_virtual: false,
    taa_applicable: true,
  },
  product_manufacturer: {
    name: 'Dell',
  },
  manufacturer_part_num: 'LAPTOP100',
  vendor_sku: '12345',
  price: 999,
  status: ProductStatusEnum.Pending,
  product_properties: [
    {
      product_type_property: {
        product_property: 'Display Diagonal Size',
        display_name: 'Screen size (inch)',
        is_displayed: true,
        value_type: '',
      },
      value: '13',
    },
    {
      product_type_property: {
        product_property: 'Available Types of Ports',
        display_name: 'Port types',
        is_displayed: false,
        value_type: '',
      },
      value: 'USB',
    },
  ],
  product_images: [],
  related_product_categories: [
    {
      id: 'mock-warranties-category',
      name: RelatedProductCategoryNameEnum.Warranties,
      product_id: '0c3efc59-cfc2-448f-8e5b-ce35bac4983b',
      selection_type: 'OPTIONAL_ONE',
      default_product_id: storefrontWarranty1.id,
      related_products: [storefrontWarranty1, storefrontWarranty2],
    },
    {
      id: 'mock-accessories-category',
      name: RelatedProductCategoryNameEnum.Accessories,
      product_id: '0c3efc59-cfc2-448f-8e5b-ce35bac4983b',
      selection_type: 'OPTIONAL_MANY',
      related_products: [storefrontAccessory1],
    },
  ],
};

const newFoundLaptop0: NewProductFoundDto = {
  vendor_sku: '11110',
  product_type_name: 'laptop',
  name: 'Dell Laptop Latitude 0 i5 16GB 512GB',
  manufacturer_part_number: 'PART1110',
  manufacturer_name: 'Dell',
  model: 'Latitude 0',
  msrp: 1099,
  unit_cost: 1000,
  already_exists: false,
};

const newFoundLaptop1: NewProductFoundDto = {
  vendor_sku: '11111',
  product_type_name: 'laptop',
  name: 'Dell Laptop Latitude 1 i7 16GB 512GB',
  manufacturer_part_number: 'PART1111',
  manufacturer_name: 'Dell',
  model: 'Latitude 1',
  msrp: 1199,
  unit_cost: 1100,
  already_exists: true,
};

const newFoundLaptop2: NewProductFoundDto = {
  vendor_sku: '11112',
  product_type_name: 'laptop',
  name: 'Dell Laptop Latitude 2 i7 32GB 512GB',
  manufacturer_part_number: 'PART1112',
  manufacturer_name: 'Dell',
  model: 'Latitude 2',
  msrp: 1299,
  unit_cost: 1200,
  already_exists: false,
};

const newFoundLaptop3: NewProductFoundDto = {
  vendor_sku: '11113',
  product_type_name: 'laptop',
  name: 'Dell Laptop Latitude 3 i7 32GB 1TB',
  manufacturer_part_number: 'PART1113',
  manufacturer_name: 'Dell',
  model: 'Latitude 3',
  msrp: 1499,
  unit_cost: 1400,
  already_exists: false,
};

const newFoundLaptop4: NewProductFoundDto = {
  vendor_sku: '11114',
  product_type_name: 'laptop',
  name: 'Dell Laptop Latitude 4 i7 32GB 2TB',
  manufacturer_part_number: 'PART1114',
  manufacturer_name: 'Dell',
  model: 'Latitude 4',
  msrp: 1499,
  unit_cost: 1400,
  already_exists: false,
};

const foundWarranty1: ProductFoundDto = {
  product_id: '12345',
  vendor_sku: '22221',
  name: '3 years',
  product_type_name: 'warranty',
  manufacturer_part_num: 'PART22221',
  manufacturer_name: 'Dell',
  price: 79,
  country_code: 'US',
  product_origin_name: 'TDSynnex',
};

const foundAccessory1: ProductFoundDto = {
  product_id: '54321',
  vendor_sku: '33331',
  name: 'Laptop Backpack',
  product_type_name: 'accessory',
  manufacturer_part_num: 'PART33331',
  manufacturer_name: 'Dell',
  price: 49,
  country_code: 'US',
  product_origin_name: 'TDSynnex',
};

export const allProductsProfile = [laptopProfile1];

export const allProducts = [laptop1];

export const allNewProductsFound = [
  newFoundLaptop0,
  newFoundLaptop1,
  newFoundLaptop2,
  newFoundLaptop3,
  newFoundLaptop4,
];

export const allProductsFound = [foundWarranty1, foundAccessory1];

export const manufacturers: manufacturerDto[] = [
  {
    id: '1111',
    name: 'Apple',
  },
  {
    id: '2222',
    name: 'Dell',
  },
];

export const productTypes: ProductTypeDto[] = [
  {
    id: '1000',
    name: ProductTypeName.Laptop,
    tax_code: 'TAX1000',
    is_virtual: false,
    allows_warehousing: true,
    taa_applicable: true,
  },
  {
    id: '2000',
    name: ProductTypeName.Warranty,
    tax_code: 'TAX2000',
    is_virtual: true,
    allows_warehousing: false,
    taa_applicable: true,
  },
  {
    id: '3000',
    name: ProductTypeName.Accessory,
    tax_code: 'TAX3000',
    is_virtual: false,
    allows_warehousing: true,
    taa_applicable: false,
  },
];

export const productAIDescription = {
  description:
    'A powerful and reliable laptop built for everyday business use, with all-day battery life and a durable design.',
};

export const productSuggestions: ProductSuggestionsResponseDto = {
  company_products: [laptop1],
  all_employee_group_products: [laptop1],
  employee_groups: [
    {
      id: engineeringGroup.id,
      name: engineeringGroup.name,
      products: [laptop1],
    },
  ],
};

export const productMarginRules: ProductMarginsDto = {
  applicable_rules: [
    {
      rule_id: 'margin-rule-product',
      type: ProductMarginRuleType.ByProduct,
      margin_percent: 12,
      priority: 1,
    },
    {
      rule_id: 'margin-rule-default',
      type: ProductMarginRuleType.Default,
      margin_percent: 8,
      priority: 5,
    },
  ],
  applied_margin_rule_id: 'margin-rule-product',
};
